// Standalone per-room Scenes screen (full page). Thin wrapper around the shared
// RoomScenesManager — the same logic + editor also power the inline scenes strip
// on the room's device grid (DesktopShell).

import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import RoomScenesManager from './RoomScenesManager';

export default function RoomScenesScreen() {
  const { roomId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <RoomScenesManager
      variant="page"
      roomId={roomId}
      roomName={state?.name || 'Room'}
      initialDevices={state?.devices || null}
      onBack={() => navigate(-1)}
    />
  );
}
